var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSuccessInverted = function SvgSuccessInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 8,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#06CF7F",
    d: "M14.01 16.218l3.795-4.002a.675.675 0 01.99 0 .767.767 0 010 1.044l-4.29 4.524a.675.675 0 01-.99 0l-2.31-2.436a.767.767 0 010-1.044.675.675 0 01.99 0l1.815 1.914z"
  }))));
};
export default SvgSuccessInverted;